// The fixed-timestep transition: pipe the state through every stage in order.
// Each stage is a pure (state, input) => state reducer.

import type { GameState, FrameInput } from '../state/types';
import type { Reducer, Step } from './contracts';
import { applyPhaseTransitions } from './phase';
import { releaseSpawns, spawnFlying } from './spawning';
import { applyFire } from './fire';
import { integrateEnemies } from './integrateEnemies';
import { integratePlayers } from './integratePlayers';
import { integrateFlying } from './integrateFlying';
import { advanceExplosions } from './explosions';
import { resolveCollisions } from './collision';
import { applyScoring } from '../scoring/scoring';
import { resolveGroundImpacts } from './groundImpact';
import { checkWaveComplete, checkGameOver } from './waveResolution';

const STAGES: readonly Reducer[] = [
  applyPhaseTransitions,
  releaseSpawns,
  spawnFlying,
  applyFire,
  integrateEnemies,
  integratePlayers,
  integrateFlying,
  advanceExplosions,
  resolveCollisions,
  applyScoring,
  resolveGroundImpacts,
  checkWaveComplete,
  checkGameOver,
];

export const step: Step = (state: GameState, input: FrameInput): GameState =>
  STAGES.reduce((s, stage) => stage(s, input), state);
